import baseAPI from '../axiosApi'

const api={
    info:'/api-ir/master/report/',
}

export function info (teacherId,schoolYear) {
    return baseAPI.axiosData(api.info+teacherId+'/'+schoolYear,'get')
}
